module.exports = __webpack_public_path__ + "media/images/hero/glyph-d4-8e44f9b5ad17ac44d5ae9f46d4e84056.svg";